// extracted by mini-css-extract-plugin
export default {"createButton":"PopUpButton_createButton__D7ldI","createIcon":"PopUpButton_createIcon__DVtU1","buttonsBlock":"PopUpButton_buttonsBlock__KhEkS"};